/**
 * Правовые реквизиты и версия документов (Privacy Policy, Terms of Use).
 *
 * Юрлица у продукта нет: оператор — физическое лицо, самозанятая
 * (тот же оператор, что в уведомлении РКН № 100454825 по ст. 22). Адрес для
 * обращений — тот же, что в уведомлении РКН. Версия документов — тот же принцип, что и у
 * CONSENT_VERSION в consent.ts: меняется вместе с текстом, чтобы прежние
 * редакции оставались отличимы от новой.
 */
export const LEGAL_DOCUMENT_VERSION = '2026-10-22';

export const DATA_CONTROLLER_NAME = 'Хоменко Марина Владимировна (самозанятая)';

export const DATA_CONTROLLER_CONTACT_EMAIL = 'astragoroskop@vk.com';

/** Минимальный возраст пользователя: подтверждается при первом запуске и указан в документах. */
export const MIN_USER_AGE = 18;
